import { tokenInstance } from 'lib/axios/instance';

export const getMatchedAvatars = async (id) => {
  const { data } = await tokenInstance.get(`/api/v1/team-managers/match/${id}`);
  return data;
};
